import { BrowseByTitlePage } from "@/common/components/browse-by-title/BrowseByTitle";
import { PAGE_TITLE } from "@/common/constants/constants";
import Head from "next/head";

const BrowseByTitle = () => {
  return (
    <>
      <Head>
        <title>{PAGE_TITLE.BROWSE_BY_TITLE}</title>
        <meta name="description" content="JozyJobs app" />
      </Head>
      <BrowseByTitlePage />
    </>
  );
};
export default BrowseByTitle;
